import { Checkbox } from 'antd';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { Label } from './Typography';

export const AppCheckbox = styled(Checkbox)`
  transform: scale(1.5);
  .ant-checkbox-inner {
    border-radius: 100%;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${Color.decorative.onAccent};
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: 2px solid
      ${appOverride({
        nerva: Color.content.accent,
        default: 'white',
      })};
    border-top: 0;
    border-left: 0;
  }
`;

export const CheckboxInput = styled.input`
  margin: 0;
  -webkit-appearance: none;
  appearance: none;
  color: ${Color.flow.default};
  /* Start - Following needed for iOS */
  height: 1px;
  left: -10000px;
  position: absolute;
  width: 1px;
  /* End */
`;

export const CheckboxLabel = styled(Label)<{ checkboxInnerIcon: string }>`
  /* Same as BodySM */
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 24px;
  display: flex;
  align-items: center;
  color: ${Color.flow.default};
  overflow-x: hidden;
  cursor: pointer;
  word-break: keep-all;
  transition: all 0.15s ease-in;
  left: 0px;
`;
